class Ready {
    _isReady = false;
    _data = null;
    readyCallbacks = [];
    exec() {
        while (this.readyCallbacks.length) {
            const callback = this.readyCallbacks.pop();
            callback && callback(this._data);
        }
    }
    ready(callback) {
        this.readyCallbacks.push(callback);
        if (this._isReady) {
            this.exec();
        }
    }
    solved(data) {
        this._data = data;
        this._isReady = true;
        this.exec();
    }
    resetState() {
      this._data = null;
      this._isReady = false;
      this.readyCallbacks = [];
    }
}

export const I18nReady = new Ready();

export const shoppingCartReady = new Ready();

export const shoppingCartPlanInitReady = new Ready();

export const routerReady = new Ready();

export default Ready;
